"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

var _Functions = require("../core/Functions");

var IMEAware = (0, _utils.eventHandlerDecoratorFactory)({
  displayNameFunc: function displayNameFunc(Component) {
    return "IMEAware(" + (0, _getComponentName.default)(Component) + ")";
  },
  eventHandlers: {
    onCompositionStart: function onCompositionStart(evt) {
      this.setState({
        composing: true
      });
      (0, _Functions.callIfPossible)(this.props.onCompositionStart, evt);
    },
    onCompositionEnd: function onCompositionEnd(evt) {
      this.setState({
        composing: false
      });
      (0, _Functions.callIfPossible)(this.props.onCompositionEnd, evt);
    }
  },
  getPropsForRender: function getPropsForRender(props, state) {
    return (0, _extends2.default)({}, props, {
      _composing: state.composing || false
    });
  }
});
var _default = IMEAware;
exports.default = _default;
module.exports = exports.default;